import React from "react";
import pilot1 from "../../assets/OfferingB/pilot1.svg";
import pilot2 from "../../assets/OfferingB/pilot2.svg";
import pilot3 from "../../assets/OfferingB/pilot3.svg";
import pilot from "../../assets/OfferingB/pic3.svg";

const background = "https://storage.googleapis.com/think41-web-new/assets/OfferingB/close_white_fabric.svg"

const features = [
  {
    icon: pilot1,
    text: "Industrialize AI solutions beyond proof-of-concept",
    description:
      "Scale AI projects from initial experiments to fully operational enterprise solutions that deliver consistent, measurable business value and impact.",
  },
  {
    icon: pilot2,
    text: "Align data, infrastructure, and experience layers",
    description:
      "Coordinate data management, technology platforms, and user experience design to create seamless and efficient AI-driven workflows across the organization.",
  },
  {
    icon: pilot3,
    text: "Ensure production-grade reliability and governance",
    description:
      "Implement robust monitoring, compliance, and optimization practices to maintain AI systems’ stability, security, and high performance in production environments.",
  },
];

const PilotProduction = () => {
  return (
    <section
      id="ai_engineering"
      className="
        w-full
        bg-cover
        bg-center
        bg-no-repeat
      "
      style={{
               backgroundImage: `url(${background})`,
             }}
    >
      {/* ——— Mobile Only ——— */}
      <div className="md:hidden flex flex-col items-center px-5 py-10">
        {/* 1. Heading */}
        <h1 className="text-[24px] font-bold mb-2 w-full font-montserrat">
          Take your Pilot to Production
        </h1>

        {/* 2. Paragraph */}
        <p className="text-[16px] font-light mb-6 leading-7 font-roboto w-full">
          Move from pilot to production with robust AI deployment frameworks
          tailored for the enterprise workflows.
        </p>

        {/* 3. Main Image */}
        <div className="w-full flex justify-center mb-6">
          <img
            src={pilot}
            alt="pilot to production"
            className="w-[80%] max-w-[350px]"
          />
        </div>

        {/* 4. SVG Array */}
        <div className="flex flex-col items-center space-y-4 w-full">
          {features.map((feature, i) => (
            <div
              key={i}
              className="bg-white rounded-md shadow overflow-hidden text-[#2D3139] px-[20px] py-[16px] font-[16px] h-[80px] flex items-center w-full"
            >
              <p className="font-roboto">{feature.text}</p>
            </div>
          ))}
        </div>
      </div>


      {/* desktop view */}
      <div className="hidden md:flex w-full max-w-[1440px] mx-auto min-h-[800px] px-[120px] py-20 gap-20">
        {/* Left Side */}
        <div className="flex flex-col w-[615px] justify-center">
          {/* Title */}
          <div>
            <h1 className="text-[40px] font-bold bg-gradient-to-r from-black to-[#0060C7] bg-clip-text text-transparent font-montserrat leading-tight">
              Take your Pilot to Production
            </h1>
            <p className="mt-4 text-[16px] leading-7 font-light font-roboto text-gray-700">
              Move from pilot to production with robust AI deployment frameworks
              tailored for the enterprise workflows.
            </p>
          </div>

          {/* Cards */}
          <div className="flex flex-col gap-[30px] mt-[30px] ">
            {features.map((feature, index) => (
              <div
                className="w-[654px] gap-y-2  shrink-0 flex flex-col justify-between p-[20px] rounded bg-white shadow-[inset_0px_0px_0px_1.171px_#E1E5EB,_0px_1.171px_3.514px_rgba(31,34,41,0.08)]"
                key={index}
              >
                <div className="flex gap-[18px] items-center">
                  <img
                    src={feature.icon}
                    alt=""
                    className="w-[30px] h-[30px]"
                  />
                  <h3 className="text-[#2D3139] font-roboto text-2xl font-medium leading-[28.11px]">
                    {feature.text}
                  </h3>
                </div>
                <p className="text-[#2D3139] font-roboto text-base font-light leading-6">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side */}
        <div className="flex justify-center items-center flex-1">
          <img
            src={pilot}
            alt="Pilot to Production Diagram"
            className="max-w-full h-auto object-contain"
          />
        </div>
      </div>


    </section>
  );
};

export default PilotProduction;
